import React from 'react';
import { Alert } from 'reactstrap';

const AddSubCategory = ({ subCategory, handleChange, addNewSubCategory,error, alert, dismiss,disableValue }) => {
  return (
    <React.Fragment>
      <div>
        <Alert className="badge-content" color="success" isOpen={alert} toggle={dismiss}>
          New Sub-Category Added
        </Alert>
        <div className="row form-group">
          <div className="col-sm-1" />
          <div className="col-sm-3">
            <label for="exampleInputEmail1">SubCategory Name</label>
          </div>
          <div className="col-sm-7">
            <input type="text" class="form-control" id="subCategory" name="subCategory" placeholder="Enter Sub-category" onChange={handleChange} value={subCategory} />
          </div>
          <div className="col-sm-1" />
        </div>
        <div className="row form-group">
          <div className="col-sm-4" />
          <span className="modal-error-show">{error}</span>
        </div>

        <div className="row form-group">
          <div className="col-sm-4" />
          <div className="col-sm-4">
            <button type="button" class="btn btn-primary" disabled={disableValue} onClick={addNewSubCategory} >
              Submit
            </button>
          </div>
          <div className="col-sm-4" />
        </div>
      </div>
    </React.Fragment>
  );
};

export default AddSubCategory;
